<template>
  <a
    :href="`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`"
    class="share"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src="@/assets/line-logo.svg" alt="分享到 Line" />
  </a>
</template>

<script>
import { brand } from '../../content'

export default {
  name: 'UiShareLine',
  data() {
    return {
      url: `https://www.mirrormedia.mg/campaigns/whisky2021-${brand}/index.html`,
    }
  },
}
</script>

<style lang="scss" scoped>
.share {
  display: block;
  width: 36px;
}
</style>